import {
  Alert,
  Autocomplete,
  Button,
  CircularProgress,
  Grid2,
  Paper,
  Snackbar,
  Stack,
  TextField,
  Typography,
  InputAdornment,
  IconButton,
} from "@mui/material";
import React, { useContext, useState, useRef, useEffect } from "react";
import AddIcon from "@mui/icons-material/Add";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import AddMicroTarget from "./AddMicroTarget";
import SharedStateContext from "../../../../SharedStateProvider";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Box } from "@mui/system";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { websiteTargetEndPointLogic } from "../../../../../logic/AssetManagement/WebsiteTarget/websiteTargetEndPointLogic";
import {
  setDisplayErrorSnackBar,
  setIsLoading,
} from "../../../../../features/userSlice";
import { NumericFormat } from "react-number-format";
import store from "../../../../../store";
import { useSelector } from "react-redux";
import MicroProjectionsPopup from "./Microprojectionspopup";

interface Props {
  oauthTokenHeader: any;
  response: any;
}

const NewTarget = ({ oauthTokenHeader }: Props) => {
  const [selectedPeriod, setSelectedPeriod] = useState("") as any;

  const websiteTargetList = useSelector(
    (state: any) => state.websiteTarget.websiteTargetList,
  );
  const generatePeriodList = () => {
    const periods = [];
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();

    // Generate future 1 years
    for (let year = currentYear; year <= currentYear + 1; year++) {
      for (let month = 0; month < 12; month++) {
        const formattedMonth = String(month + 1).padStart(2, "0"); // Format month as MM
        const formattedYear = String(year).slice(-2); // Get last two digits of the year
        periods.push({
          label: `${formattedMonth}/${formattedYear}`,
          value: `${year}-${formattedMonth}-01`,
        }); // Add value for "YYYY-MM-DD"
      }
    }

    // Generate past 1 years
    for (let year = currentYear - 1; year < currentYear; year++) {
      for (let month = currentMonth; month < 12; month++) {
        const formattedMonth = String(month + 1).padStart(2, "0"); // Format month as MM
        const formattedYear = String(year).slice(-2); // Get last two digits of the year
        periods.push({
          label: `${formattedMonth}/${formattedYear}`,
          value: `${year}-${formattedMonth}-01`,
        }); // Add value for "YYYY-MM-DD"
      }
    }

    return periods;
  };

  // Get the period list and sort it in descending order
  const periodList = generatePeriodList().sort((a, b) => {
    const [monthA, yearA] = a.label.split("/").map(Number);
    const [monthB, yearB] = b.label.split("/").map(Number);
    return yearB - yearA || monthB - monthA;
  });

  const monthsSet = websiteTargetList?.map((item: any) => item.month); // Extract the years from websiteTargetList
  // Filter periodList where the value is NOT in the months set(that is already created)
  const filterPeriodList = periodList?.filter(
    (item) => !monthsSet.includes(item.value),
  );

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const selectedSite = searchParams.get("selectedSite") as any;
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [microTargets, setMicroTargets] = useState([]) as any;
  const [microTargetsData, setMicroTargetsData] = useState([]) as any;
  const location = useLocation();
  const [createdTargetUid, setCreatedTargetUid] = useState("") as any;
  const { periods = [] } = location.state || {};
  const { handleCreateClose } = useContext(SharedStateContext);
  const [ftd, setFtd] = useState("") as any;
  const [profit, setProfit] = useState("") as any;
  const [nrpu, setNrpu] = useState("") as any;
  const [spend, setSpend] = useState("") as any;
  const [clicks, setClicks] = useState("") as any;
  const [cvr, setCvr] = useState("") as any;
  const [cac, setCac] = useState("") as any;
  const [cpa, setCpa] = useState("") as any;
  const [cpc, setCpc] = useState("") as any;
  const [rs, setRs] = useState("") as any;
  const [totalIncome, setTotalIncome] = useState("") as any;
  const [cpaPv, setCpaPv] = useState("") as any;
  const [rsPv, setRsPv] = useState("") as any;
  const [pv, setPv] = useState("") as any;
  const [netRevenue, setNetRevenue] = useState("") as any;
  const [avgRsDeal, setAvgRsDeal] = useState("") as any;
  const [epc, setEpc] = useState("") as any;
  const [epcCpa, setEpcCpa] = useState("") as any;
  const [epcRs, setEpcRs] = useState("") as any;
  const [growthTarget, setGrowthTarget] = useState("") as any;
  const [activeUsers, setActiveUsers] = useState("") as any;
  const [oldActiveUsers, setOldActiveUsers] = useState("") as any;
  const [acquiredActiveUsers, setAcquiredActiveUsers] = useState("") as any;
  const [charnRate, setCharnRate] = useState("") as any;
  const [acquiredToFtd, setAcquiredToFtd] = useState("") as any;
  const [avgNetRevToActiveUsers, setAvgNetRevToActiveUsers] = useState(
    "",
  ) as any;
  const [brToNgActiveRs, setBrToNgActiveRs] = useState("") as any;
  const [isValid, setIsValid] = useState(true);
  const [targetCreated, setTargetCreated] = useState(false); // Add this new state

  //new changes(https://optival.atlassian.net/browse/GR-21159)
  const [showMicroPopup, setShowMicroPopup] = useState(false);

  // Define interface for the micro target ref
  interface MicroTargetRef {
    getMicroTargetData: () => {
      geo?: any;
      product?: any;
      [key: string]: any;
    };
  }

  const microTargetRefs = useRef<React.RefObject<MicroTargetRef>[]>([]);

  useEffect(() => {
    microTargetRefs.current = microTargets.map(() =>
      React.createRef<MicroTargetRef>(),
    ); // Initialize refs array with the initial microTargets
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Empty dependency array means this runs once on mount

  const handleAddMicroTarget = () => {
    const newRef = React.createRef<MicroTargetRef>();
    setMicroTargets((prev: any) => [...prev, {}]);
    microTargetRefs.current = [...microTargetRefs.current, newRef];
  };

  const handleCollectMicroTargets = async () => {
    const mappedData = microTargetRefs.current.map((ref) => {
      const data = ref?.current?.getMicroTargetData();
      return data;
    });
    const validMicroTargets = mappedData
      .filter((data) => data?.geo && data?.product_type)
      .map((data: any) => ({
        ...data,
        cvr: Math.abs(parseFloat((parseFloat(data.cvr) / 100).toFixed(4))) || 0, // Use data.cvr instead of cvr
      }));

    setMicroTargetsData(validMicroTargets);
    if (validMicroTargets.length === 0) {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Please fill the mandatory fields",
          type: "error",
        }),
      );
    }
    try {
      if (createdTargetUid) {
        const apiCalls = validMicroTargets.map(
          (
            microTarget, // Create an array of promises for each micro target API call
          ) =>
            websiteTargetEndPointLogic.createWebsiteMicroTarget(
              oauthTokenHeader,
              microTarget,
              createdTargetUid,
            ), // Send individual micro target data
        );

        const responses = await Promise.all(apiCalls);

        const allSuccessful = responses.every(
          (res) => res?.reason === "success",
        );

        if (!allSuccessful) {
          const failedReasons = [
            ...new Set(
              responses
                .filter((res) => res?.reason !== "success")
                .map((res) => res?.reason),
            ),
          ];

          if (failedReasons.length > 0) {
            // Join all reasons into a single error message
            throw new Error(
              failedReasons.filter(Boolean).join("  ") ||
                "One or more micro targets failed to add.",
            );
          }
        }

        handleCancelClick();
        store.dispatch(
          setDisplayErrorSnackBar({
            message: "Website Micro Target Added Successfully",
            type: "success",
          }),
        );
      } else {
        store.dispatch(
          setDisplayErrorSnackBar({
            message: "Error in creating micro targets",
            type: "error",
          }),
        );
      }
    } catch (error: any) {
      store.dispatch(
        setDisplayErrorSnackBar({
          message:
            error?.parsedText || error?.message || "Error while fetching data.",
          type: "error",
        }),
      );
    }
  };
  const handleRemoveMicroTarget = (index: number) => {
    setMicroTargets((prev: any) =>
      prev.filter((_: any, i: any) => i !== index),
    );
    microTargetRefs.current = microTargetRefs.current.filter(
      (_, i) => i !== index,
    );
  };

  const handleCancelClick = () => {
    handleCreateClose();
    navigate(`/business_leader/website_projection${location.search}`);
  };

  const [expanded, setExpanded] = React.useState<string | false>(false);

  const handleChange = (panel: string) => (_: unknown, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };

  const createNewTarget = async () => {
    const data = {
      shared_uid: selectedSite,
      month: selectedPeriod,
      spend: Math.abs(parseFloat(spend)) || 0.0,
      clicks: Math.abs(parseFloat(clicks)) || 0.0,
      ftd: Math.abs(parseFloat(ftd)) || 0.0,
      cvr: Math.abs(parseFloat((parseFloat(cvr) / 100).toFixed(4))) || 0,
      cac: Math.abs(parseFloat(cac)) || 0.0,
      profit: Math.abs(parseFloat(profit)) || 0.0,
      cpc: Math.abs(parseFloat(cpc)) || 0.0,
      nrpu: Math.abs(parseFloat(nrpu)) || 0.0,
      cpa: Math.abs(parseFloat(cpa)) || 0.0,
      rs: Math.abs(parseFloat(rs)) || 0.0,
      total_income: Math.abs(parseFloat(totalIncome)) || 0.0,
      cpa_pv: Math.abs(parseFloat(cpaPv)) || 0.0,
      rs_pv: Math.abs(parseFloat(rsPv)) || 0.0,
      pv: Math.abs(parseFloat(pv)) || 0.0,
      growth_target: Number((parseFloat(growthTarget) / 100).toFixed(4)) || 0,
      active_users: Math.abs(parseInt(activeUsers)) || 0,
      old_active_users: Math.abs(parseInt(oldActiveUsers)) || 0,
      acquired_active_users: Math.abs(parseInt(acquiredActiveUsers)) || 0,
      churn_rate:
        Math.abs(parseFloat((parseFloat(charnRate) / 100).toFixed(4))) || 0,
      ratio_between_acquired_to_ftd:
        Math.abs(parseFloat((parseFloat(acquiredToFtd) / 100).toFixed(4))) || 0,
      avg_net_rev_per_active_user:
        Math.abs(parseFloat(avgNetRevToActiveUsers)) || 0.0,
      net_revenue: Math.abs(parseFloat(netRevenue)) || 0.0,
      avg_rs_deal_p:
        Math.abs(parseFloat((parseFloat(avgRsDeal) / 100).toFixed(4))) || 0,
      br_to_ng_active_rs_ratio:
        Math.abs(parseFloat((parseFloat(brToNgActiveRs) / 100).toFixed(4))) ||
        0,
      epc_cpa: Math.abs(parseFloat(epcCpa)) || 0.0,
      epc_rs: Math.abs(parseFloat(epcRs)) || 0.0,
      epc: Math.abs(parseFloat(epc)) || 0.0,
      micro_targets: microTargetsData,
    };
    setLoading(true);
    setIsLoading(false);
    if (oauthTokenHeader) {
      return websiteTargetEndPointLogic
        .postWebsiteTarget(
          oauthTokenHeader,
          data,
          setCreatedTargetUid,
          selectedSite,
        )
        .then(() => {
          setTargetCreated(true);
          setSnackbarOpen(true);
          setSnackbarMessage("Website Target created successfully");

          //new changes(https://optival.atlassian.net/browse/GR-21159)
          setTimeout(() => {
            setShowMicroPopup(true);
          }, 2200);
        })
        .catch((error: any) => {
          setLoading(false);
          store.dispatch(
            setDisplayErrorSnackBar({
              message: error?.parsedText || "Error while fetching data.",
              type: "error",
            }),
          );
        })
        .finally(() => {
          setLoading(false);
          setIsLoading(false);
        });
    } else {
      setIsLoading(false);
      setLoading(false);
      throw new Error("User doesn't have permissions to create new targets");
    }
  };

  const validate = async () => {
    if (selectedPeriod === "") {
      setSnackbarOpen(true);
      setSnackbarMessage("Please select a period");
      setIsValid(false);
      return false;
    }

    if (periods.includes(selectedPeriod)) {
      setSnackbarOpen(true);
      setSnackbarMessage(
        "Target for month and website already exists. Please select a different period",
      );
      setIsValid(false);
      return false;
    }

    const mandatoryFields = [
      { name: "Spend", value: spend },
      { name: "FTD", value: ftd },
      { name: "Profit", value: profit },
      { name: "NRPU", value: nrpu },
      { name: "RS", value: rs },
      { name: "Clicks", value: clicks },
      { name: "CPC", value: cpc },
      { name: "CAC", value: cac },
      { name: "Total Income", value: totalIncome },
      { name: "Active Users", value: activeUsers },
    ];

    const emptyFields = mandatoryFields
      .filter((field) => !field.value)
      .map((field) => field.name);

    if (emptyFields.length > 0) {
      setSnackbarOpen(true);
      setSnackbarMessage(
        `Please fill the mandatory fields: ${emptyFields.join(", ")}`,
      );
      setIsValid(false);
      return false;
    }

    setIsValid(true);
    return true;
  };

  const handleCreateTarget = async () => {
    try {
      const isFormValid = await validate();
      if (!isFormValid) return;
      setLoading(true);
      await createNewTarget();
    } catch (error: any) {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: error?.parsedText || "Error while fetching data.",
          type: "error",
        }),
      );
    } finally {
      setIsLoading(false);
      setLoading(false);
    }
  };

  const renderSnackbar = () => {
    return (
      <Snackbar
        sx={{ zIndex: "9999999" }}
        open={snackbarOpen}
        autoHideDuration={5500}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        onClose={() => setSnackbarOpen(false)}
      >
        <Alert
          elevation={6}
          //variant="filled"
          onClose={() => setSnackbarOpen(false)}
          severity={
            snackbarMessage.includes("Error") || isValid ? "success" : "error"
          }
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    );
  };

  return (
    <>
      {renderSnackbar()}
      <Paper>
        <Box sx={{ padding: "16px !important" }}>
          <Typography fontSize={24} mb={2}>
            Set New Projection
          </Typography>
          <Grid2
            container
            mt={1}
            columnSpacing={3}
            mb={1}
            justifyContent={"space-between"}
          >
            <Grid2 size={4}>
              <Autocomplete
                sx={{ width: "100%" }}
                options={filterPeriodList}
                getOptionLabel={(option: any) => option.label}
                onChange={(_, newValue) => {
                  if (newValue) {
                    setSelectedPeriod(newValue.value);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Month & Year"
                    label="Period"
                    required
                    InputProps={{
                      ...params.InputProps,
                    }}
                    color="secondary"
                  />
                )}
                size="small"
              />
            </Grid2>
            <Grid2 size={5}>
              <Stack flexDirection={"row"} justifyContent={"end"} gap={1}>
                <Button color="secondary" variant="text">
                  <Stack onClick={handleCancelClick}>Cancel</Stack>
                </Button>
                <Button
                  color="secondary"
                  disabled={
                    !createdTargetUid ||
                    createdTargetUid === "" ||
                    createdTargetUid === null
                  }
                  variant="outlined"
                  onClick={handleAddMicroTarget}
                >
                  <Stack flexDirection={"row"} alignItems={"center"} gap={1}>
                    Add micro projection <AddIcon fontSize="small" />
                  </Stack>
                </Button>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={handleCreateTarget}
                  data-tracker="96"
                  disabled={targetCreated}
                  sx={{ textTransform: "uppercase" }}
                >
                  <Stack flexDirection={"row"} gap={1}>
                    {loading ? (
                      <CircularProgress size={24} color="inherit" />
                    ) : (
                      "Set Projection"
                    )}
                    <CheckIcon fontSize="small" />
                  </Stack>
                </Button>
              </Stack>
            </Grid2>
          </Grid2>
        </Box>
        <Grid2 container columnSpacing={0}>
          <Grid2 size={12}>
            <Accordion
              expanded={expanded === "panel1"}
              onChange={handleChange("panel1")}
              className="setTargetList"
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon color="secondary" />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
              >
                <Typography
                  component="span"
                  sx={{ width: "33%", flexShrink: 0 }}
                >
                  Key metrics
                </Typography>
                <Typography component="span" sx={{ color: "text.secondary" }}>
                  Contains Mandatory Fields
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid2 container mt={2} columnSpacing={3}>
                  <Grid2 size={4}>
                    <NumericFormat
                      customInput={TextField}
                      label="FTD"
                      variant="outlined"
                      fullWidth
                      color="secondary"
                      size="small"
                      required
                      value={ftd}
                      decimalScale={2}
                      onValueChange={(values) => setFtd(values.value)}
                      thousandSeparator=","
                      sx={{ width: "100%" }}
                    />
                  </Grid2>
                  <Grid2 size={4}>
                    <NumericFormat
                      customInput={TextField}
                      label="Profit"
                      placeholder="In USD"
                      variant="outlined"
                      fullWidth
                      color="secondary"
                      size="small"
                      required
                      value={profit}
                      onValueChange={(values) => setProfit(values.value)}
                      thousandSeparator=","
                      decimalScale={2}
                      sx={{ width: "100%" }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">$</InputAdornment>
                        ),
                      }}
                    />
                  </Grid2>
                  <Grid2 size={4}>
                    <NumericFormat
                      customInput={TextField}
                      label="NRPU"
                      placeholder="In USD"
                      variant="outlined"
                      fullWidth
                      color="secondary"
                      size="small"
                      required
                      value={nrpu}
                      onValueChange={(values) => setNrpu(values.value)}
                      thousandSeparator=","
                      decimalScale={2}
                      sx={{ width: "100%" }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">$</InputAdornment>
                        ),
                      }}
                    />
                  </Grid2>
                  <Grid2 size={4} mt={2}>
                    <NumericFormat
                      customInput={TextField}
                      label="Spend"
                      placeholder="In USD"
                      variant="outlined"
                      fullWidth
                      color="secondary"
                      size="small"
                      required
                      value={spend}
                      onValueChange={(values) => setSpend(values.value)}
                      thousandSeparator=","
                      decimalScale={2}
                      sx={{ width: "100%" }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">$</InputAdornment>
                        ),
                      }}
                    />
                  </Grid2>
                  <Grid2 size={4} mt={2}>
                    <NumericFormat
                      customInput={TextField}
                      label="Clicks"
                      placeholder=""
                      variant="outlined"
                      fullWidth
                      required
                      color="secondary"
                      size="small"
                      value={clicks}
                      decimalScale={2}
                      onValueChange={(values) => setClicks(values.value)}
                      isAllowed={(values) => {
                        const { formattedValue } = values;
                        // Allow only digits and commas (block ., -, ), etc.)
                        return /^[\d,]*$/.test(formattedValue);
                      }}
                      thousandSeparator=","
                      sx={{ width: "100%" }}
                    />
                  </Grid2>
                  <Grid2 size={4} mt={2}>
                    <NumericFormat
                      customInput={TextField}
                      label="CVR"
                      placeholder="Percentage"
                      variant="outlined"
                      fullWidth
                      color="secondary"
                      size="small"
                      value={cvr}
                      onValueChange={(values) => setCvr(values.value)}
                      isAllowed={(values) => {
                        const { formattedValue } = values;
                        // Allow digits, commas, and one decimal point
                        return /^[\d,]*\.?\d*$/.test(
                          formattedValue.replace(/,/g, ""),
                        );
                      }}
                      thousandSeparator=","
                      decimalScale={2} // optional: limits to 2 decimal places
                      allowNegative={false}
                      sx={{ width: "100%" }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">%</InputAdornment>
                        ),
                      }}
                    />
                  </Grid2>
                  <Grid2 size={4} mt={2}>
                    <NumericFormat
                      customInput={TextField}
                      label="CAC"
                      placeholder="In USD"
                      variant="outlined"
                      fullWidth
                      color="secondary"
                      required
                      size="small"
                      value={cac}
                      onValueChange={(values) => setCac(values.value)}
                      thousandSeparator=","
                      decimalScale={2}
                      sx={{ width: "100%" }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">$</InputAdornment>
                        ),
                      }}
                    />
                  </Grid2>
                  <Grid2 size={4} mt={2}>
                    <NumericFormat
                      customInput={TextField}
                      label="CPC"
                      placeholder="In USD"
                      variant="outlined"
                      fullWidth
                      color="secondary"
                      required
                      size="small"
                      value={cpc}
                      onValueChange={(values) => setCpc(values.value)}
                      thousandSeparator=","
                      decimalScale={2}
                      sx={{ width: "100%" }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">$</InputAdornment>
                        ),
                      }}
                    />
                  </Grid2>
                  <Grid2 size={12}>
                    <Typography
                      fontSize={14}
                      mt={1}
                      sx={{ color: "#00000099" }}
                    >
                      Fields marked with * are mandatory.
                    </Typography>
                  </Grid2>
                </Grid2>
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expanded === "panel2"}
              onChange={handleChange("panel2")}
              className="AddMicroTargetWrap"
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon color="secondary" />}
                aria-controls="panel2bh-content"
                id="panel2bh-header"
              >
                <Typography
                  component="span"
                  sx={{ width: "33%", flexShrink: 0 }}
                >
                  Income
                </Typography>
                <Typography component="span" sx={{ color: "text.secondary" }}>
                  Contains Mandatory Fields
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid2 container mt={2} columnSpacing={3}>
                  <Grid2 size={4}>
                    <NumericFormat
                      customInput={TextField}
                      label="CPA"
                      placeholder="In USD"
                      variant="outlined"
                      fullWidth
                      color="secondary"
                      size="small"
                      value={cpa}
                      onValueChange={(values) => setCpa(values.value)}
                      thousandSeparator=","
                      decimalScale={2}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">$</InputAdornment>
                        ),
                      }}
                    />
                  </Grid2>
                  <Grid2 size={4}>
                    <NumericFormat
                      customInput={TextField}
                      label="RS"
                      placeholder="In USD"
                      variant="outlined"
                      fullWidth
                      color="secondary"
                      size="small"
                      required
                      value={rs}
                      onValueChange={(values) => setRs(values.value)}
                      thousandSeparator=","
                      decimalScale={2}
                      sx={{ width: "100%" }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">$</InputAdornment>
                        ),
                      }}
                    />
                  </Grid2>
                  <Grid2 size={4}>
                    <NumericFormat
                      customInput={TextField}
                      label="Total Income"
                      placeholder="In USD"
                      variant="outlined"
                      fullWidth
                      required
                      color="secondary"
                      size="small"
                      value={totalIncome}
                      onValueChange={(values) => setTotalIncome(values.value)}
                      thousandSeparator=","
                      decimalScale={2}
                      sx={{ width: "100%" }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">$</InputAdornment>
                        ),
                      }}
                    />
                  </Grid2>
                  <Grid2 size={4} mt={2}>
                    <NumericFormat
                      customInput={TextField}
                      label="CPA PV"
                      placeholder="In USD"
                      variant="outlined"
                      fullWidth
                      color="secondary"
                      size="small"
                      value={cpaPv}
                      onValueChange={(values) => setCpaPv(values.value)}
                      thousandSeparator=","
                      decimalScale={2}
                      sx={{ width: "100%" }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">$</InputAdornment>
                        ),
                      }}
                    />
                  </Grid2>
                  <Grid2 size={4} mt={2}>
                    <NumericFormat
                      customInput={TextField}
                      label="RS PV"
                      placeholder="In USD"
                      variant="outlined"
                      fullWidth
                      color="secondary"
                      size="small"
                      value={rsPv}
                      onValueChange={(values) => setRsPv(values.value)}
                      thousandSeparator=","
                      decimalScale={2}
                      sx={{ width: "100%" }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">$</InputAdornment>
                        ),
                      }}
                    />
                  </Grid2>
                  <Grid2 size={4} mt={2}>
                    <NumericFormat
                      customInput={TextField}
                      label="PV"
                      placeholder="In USD"
                      variant="outlined"
                      fullWidth
                      color="secondary"
                      size="small"
                      value={pv}
                      onValueChange={(values) => setPv(values.value)}
                      thousandSeparator=","
                      decimalScale={2}
                      sx={{ width: "100%" }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">$</InputAdornment>
                        ),
                      }}
                    />
                  </Grid2>
                  <Grid2 size={4} mt={2}>
                    <NumericFormat
                      customInput={TextField}
                      label="Net Revenue"
                      placeholder="In USD"
                      variant="outlined"
                      fullWidth
                      color="secondary"
                      size="small"
                      value={netRevenue}
                      required
                      onValueChange={(values) => setNetRevenue(values.value)}
                      thousandSeparator=","
                      decimalScale={2}
                      sx={{ width: "100%" }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">$</InputAdornment>
                        ),
                      }}
                    />
                  </Grid2>
                  <Grid2 size={4} mt={2}>
                    <NumericFormat
                      customInput={TextField}
                      label="Avg RS Deal"
                      placeholder="In Percentage"
                      variant="outlined"
                      fullWidth
                      color="secondary"
                      size="small"
                      value={avgRsDeal}
                      required
                      onValueChange={(values) => setAvgRsDeal(values.value)}
                      isAllowed={(values) => {
                        const { formattedValue } = values;
                        // Allow digits, commas, and one decimal point
                        return /^[\d,]*\.?\d*$/.test(
                          formattedValue.replace(/,/g, ""),
                        );
                      }}
                      thousandSeparator=","
                      decimalScale={2} // optional: limits to 2 decimal places
                      allowNegative={false}
                      sx={{ width: "100%" }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">%</InputAdornment>
                        ),
                      }}
                    />
                  </Grid2>
                  <Grid2 size={4} mt={2}>
                    <NumericFormat
                      customInput={TextField}
                      label="EPC"
                      placeholder="In USD"
                      variant="outlined"
                      fullWidth
                      color="secondary"
                      size="small"
                      value={epc}
                      required
                      onValueChange={(values) => setEpc(values.value)}
                      thousandSeparator=","
                      decimalScale={2}
                      sx={{ width: "100%" }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">$</InputAdornment>
                        ),
                      }}
                    />
                  </Grid2>
                  <Grid2 size={4} mt={2}>
                    <NumericFormat
                      customInput={TextField}
                      label="EPC CPA"
                      placeholder="In USD"
                      variant="outlined"
                      fullWidth
                      color="secondary"
                      size="small"
                      value={epcCpa}
                      required
                      onValueChange={(values) => setEpcCpa(values.value)}
                      thousandSeparator=","
                      decimalScale={2}
                      sx={{ width: "100%" }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">$</InputAdornment>
                        ),
                      }}
                    />
                  </Grid2>
                  <Grid2 size={4} mt={2}>
                    <NumericFormat
                      customInput={TextField}
                      label="EPC RS"
                      placeholder="In USD"
                      variant="outlined"
                      fullWidth
                      color="secondary"
                      size="small"
                      value={epcRs}
                      required
                      onValueChange={(values) => setEpcRs(values.value)}
                      thousandSeparator=","
                      decimalScale={2}
                      sx={{ width: "100%" }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">$</InputAdornment>
                        ),
                      }}
                    />
                  </Grid2>
                  <Grid2 size={12}>
                    <Typography
                      fontSize={14}
                      mt={1}
                      sx={{ color: "#00000099" }}
                    >
                      Fields marked with * are mandatory.
                    </Typography>
                  </Grid2>
                </Grid2>
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expanded === "panel3"}
              onChange={handleChange("panel3")}
              className="AddMicroTargetWrap"
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon color="secondary" />}
                aria-controls="panel3bh-content"
                id="panel3bh-header"
              >
                <Typography
                  component="span"
                  sx={{ width: "33%", flexShrink: 0 }}
                >
                  Performance
                </Typography>
                <Typography component="span" sx={{ color: "text.secondary" }}>
                  Contains Mandatory Fields
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid2 container mt={2} columnSpacing={3}>
                  <Grid2 size={4}>
                    <NumericFormat
                      customInput={TextField}
                      label="Growth Target"
                      placeholder="In Percentage"
                      variant="outlined"
                      fullWidth
                      color="secondary"
                      size="small"
                      value={growthTarget}
                      onValueChange={(values) => setGrowthTarget(values.value)}
                      isAllowed={(values) => {
                        const { formattedValue } = values;
                        // Allow digits, commas, optional one decimal, and leading minus
                        const cleanValue = formattedValue.replace(/,/g, "");
                        return /^-?\d*\.?\d*$/.test(cleanValue);
                      }}
                      thousandSeparator=","
                      decimalScale={4} // limits to 4 decimal places
                      allowNegative={true}
                      sx={{ width: "100%" }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">%</InputAdornment>
                        ),
                      }}
                    />
                  </Grid2>
                  <Grid2 size={4}>
                    <NumericFormat
                      customInput={TextField}
                      label="Active Users"
                      variant="outlined"
                      fullWidth
                      required
                      color="secondary"
                      size="small"
                      value={activeUsers}
                      onValueChange={(values) => setActiveUsers(values.value)}
                      isAllowed={(values) => {
                        const { formattedValue } = values;
                        // Allow only digits and commas (block ., -, ), etc.)
                        return /^[\d,]*$/.test(formattedValue);
                      }}
                      thousandSeparator=","
                      decimalScale={2}
                      sx={{ width: "100%" }}
                    />
                  </Grid2>
                  <Grid2 size={4}>
                    <NumericFormat
                      customInput={TextField}
                      label="Old Active Users"
                      variant="outlined"
                      fullWidth
                      color="secondary"
                      size="small"
                      value={oldActiveUsers}
                      onValueChange={(values) =>
                        setOldActiveUsers(values.value)
                      }
                      isAllowed={(values) => {
                        const { formattedValue } = values;
                        // Allow only digits and commas (block ., -, ), etc.)
                        return /^[\d,]*$/.test(formattedValue);
                      }}
                      thousandSeparator=","
                      decimalScale={2}
                      sx={{ width: "100%" }}
                    />
                  </Grid2>
                  <Grid2 size={4} mt={2}>
                    <NumericFormat
                      customInput={TextField}
                      label="Acquired Active Users"
                      variant="outlined"
                      fullWidth
                      color="secondary"
                      size="small"
                      value={acquiredActiveUsers}
                      onValueChange={(values) =>
                        setAcquiredActiveUsers(values.value)
                      }
                      isAllowed={(values) => {
                        const { formattedValue } = values;
                        // Allow only digits and commas (block ., -, ), etc.)
                        return /^[\d,]*$/.test(formattedValue);
                      }}
                      thousandSeparator=","
                      decimalScale={2}
                      sx={{ width: "100%" }}
                    />
                  </Grid2>
                  <Grid2 size={4} mt={2}>
                    <NumericFormat
                      customInput={TextField}
                      label="Churn Rate"
                      placeholder="In Percentage"
                      variant="outlined"
                      fullWidth
                      color="secondary"
                      size="small"
                      value={charnRate}
                      onValueChange={(values) => setCharnRate(values.value)}
                      isAllowed={(values) => {
                        const { formattedValue } = values;
                        // Allow digits, commas, and one decimal point
                        return /^[\d,]*\.?\d*$/.test(
                          formattedValue.replace(/,/g, ""),
                        );
                      }}
                      thousandSeparator=","
                      decimalScale={2} // optional: limits to 2 decimal places
                      allowNegative={false}
                      sx={{ width: "100%" }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">%</InputAdornment>
                        ),
                      }}
                    />
                  </Grid2>
                  <Grid2 size={4} mt={2}>
                    <NumericFormat
                      customInput={TextField}
                      label="Acquired to FTD"
                      placeholder="In Percentage"
                      variant="outlined"
                      fullWidth
                      color="secondary"
                      size="small"
                      value={acquiredToFtd}
                      onValueChange={(values) => setAcquiredToFtd(values.value)}
                      isAllowed={(values) => {
                        const { formattedValue } = values;
                        // Allow digits, commas, and one decimal point
                        return /^[\d,]*\.?\d*$/.test(
                          formattedValue.replace(/,/g, ""),
                        );
                      }}
                      thousandSeparator=","
                      decimalScale={2} // optional: limits to 2 decimal places
                      allowNegative={false}
                      sx={{ width: "100%" }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">%</InputAdornment>
                        ),
                      }}
                    />
                  </Grid2>
                  <Grid2 size={4} mt={2}>
                    <NumericFormat
                      customInput={TextField}
                      label="Avg Net Rev To Active Users"
                      placeholder="In USD"
                      variant="outlined"
                      fullWidth
                      color="secondary"
                      size="small"
                      value={avgNetRevToActiveUsers}
                      onValueChange={(values) =>
                        setAvgNetRevToActiveUsers(values.value)
                      }
                      thousandSeparator=","
                      decimalScale={2}
                      sx={{ width: "100%" }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">$</InputAdornment>
                        ),
                      }}
                    />
                  </Grid2>
                  <Grid2 size={4} mt={2}>
                    <NumericFormat
                      customInput={TextField}
                      label="BR to Ng Active RS"
                      placeholder="In Percentage"
                      variant="outlined"
                      fullWidth
                      color="secondary"
                      size="small"
                      value={brToNgActiveRs}
                      onValueChange={(values) =>
                        setBrToNgActiveRs(values.value)
                      }
                      isAllowed={(values) => {
                        const { formattedValue } = values;
                        // Allow digits, commas, and one decimal point
                        return /^[\d,]*\.?\d*$/.test(
                          formattedValue.replace(/,/g, ""),
                        );
                      }}
                      thousandSeparator=","
                      decimalScale={2} // optional: limits to 2 decimal places
                      allowNegative={false}
                      sx={{ width: "100%" }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">%</InputAdornment>
                        ),
                      }}
                    />
                  </Grid2>
                </Grid2>
              </AccordionDetails>
            </Accordion>
          </Grid2>
        </Grid2>
        <Box>
          {microTargets.map((_: any, index: number) => (
            <Box
              key={index}
              sx={{ display: "flex", alignItems: "flex-start", pt: 2, px: 2 }}
            >
              <AddMicroTarget
                ref={microTargetRefs.current[index]}
                oauthTokenHeader={oauthTokenHeader}
                index={index}
              />
              <IconButton
                size="small"
                onClick={() => handleRemoveMicroTarget(index)}
                sx={{ mt: 1 }}
              >
                <CloseIcon color="secondary" />
              </IconButton>
            </Box>
          ))}
          {microTargets.length > 0 && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                mt: 2,
                pb: 2,
                px: 2,
              }}
            >
              <Button
                variant="contained"
                color="secondary"
                size="medium"
                onClick={handleCollectMicroTargets}
              >
                Add All Micro Targets
              </Button>
            </Box>
          )}
        </Box>
      </Paper>

      {/*new changes(https://optival.atlassian.net/browse/GR-21159) */}
      <MicroProjectionsPopup
        open={showMicroPopup}
        onYes={() => {
          setShowMicroPopup(false);
          handleAddMicroTarget();
        }}
        onNo={() => {
          setShowMicroPopup(false);
          navigate(`/business_leader/website_projection${location.search}`); // move to main screen
        }}
      />
    </>
  );
};

export default NewTarget;
